import React, { useCallback, useEffect, useState } from 'react';
import { Box, LinkButton, Preloader, Text } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';

import { ExpressSetupStatuses } from '../ExpressSetup.types';
import { useUpdateExpressSetupStatusByIdQuery } from '../queries';

interface Props {
  orgId?: string;
  orgName?: string;
}

const AbandonedBanner: React.FC<Props> = ({
  orgId,
  orgName,
}) => {
  const [errorModal, setErrorModal] = useState(false);
  const { handleSave, isError, isLoading } = useUpdateExpressSetupStatusByIdQuery();
  const markAsPending = useCallback(() => handleSave({ 
    id: orgId,
    status: ExpressSetupStatuses.DRAFT,
  }), [handleSave, orgId]);

  useEffect(() => {
    if (isError) {
      setErrorModal(true);
    }
  }, [isError]);

  return (
    <>
      <Box
        direction="row"
        width="100%"
        height="56px"
        background="warningBorder"
        justify="center"
        align="center"
        pad={{ horizontal: 'm' }}
      >
        <Text margin={{ right: 'xxs' }} size="large">{`${orgName} is abandoned. Mark as pending to`}</Text>
        <LinkButton
          size='L'
          testId='edit-status'
          linkInlineMode
          disabled={isLoading}
          onClick={markAsPending}
        >
          {isLoading ? <Preloader testId='edit-preloader' /> : 'Edit'}
        </LinkButton>
      </Box>
      {errorModal && (
        <WarnModal
          testId="express-setup-status-wizzard-error-modal"
          visible={!!errorModal}
          onSetVisible={() => setErrorModal(false)}
          header="The server encountered an error processing the request"
          helptext={`It doesn't appear to have affected your data, but we cannot update the Express Setup status.
          Our technical staff have been automatically notified and will be looking into this with the utmost urgency.`}
          buttonText="Close"
          onSubmit={markAsPending}
          submitButtonText="Try again"
        />
      )}
    </>
  );
};

export default AbandonedBanner;
